module.exports = __webpack_public_path__ + "static/media/kocka2NOSA.23751179.png";